import { render, staticRenderFns } from "./PageReportDefect.vue?vue&type=template&id=5cafde38&scoped=true"
import script from "./PageReportDefect.vue?vue&type=script&lang=js"
export * from "./PageReportDefect.vue?vue&type=script&lang=js"
import style0 from "./PageReportDefect.vue?vue&type=style&index=0&id=5cafde38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cafde38",
  null
  
)

export default component.exports